module.exports = __webpack_public_path__ + "media/images/nomiri-logo-6b765d71df62bf4fdf1d4031ba4eea1c.png";